module.exports = __webpack_public_path__ + "img/1_015.815f52c2.jpg";